<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top" >
        <a (click)="goBack()">
            @if (operativaGroup == operativaName){
            <h3>Tetris / Ejercicio {{ year }} / {{ operativaGroup }} </h3>
            } @else {
            <h3>Tetris / Ejercicio {{ year }} / {{ operativaGroup }} / {{ operativaName }}</h3>
            }
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ driver?.employee?.full_name | qeqPipe }}</h2>
            </div>
            <!-- TODO: Hacer de esto un componente -->
            @if (driver?.status_info?.employee_status) {
            <div class="subtitle background">
                <mat-icon>check_circle</mat-icon>
                Estado: <strong>{{ driver?.status_info?.employee_status }}</strong>
                @if (driver?.status_info?.has_pending_requests) {
                <span> - Tiene peticiones pendientes</span>
                }
            </div>
            }
        </a>
        <div class="boton">
            <!-- <app-vacation-switch></app-vacation-switch> -->
            <!-- <button class="b1" mat-button>Editar</button> -->
        </div>
    </div>

    <div class="info">

        <div class="profile-picture">
            <!-- <img src="assets/images/profile-stock.png" alt="Profile Picture"> -->
            @if (driver?.employee?.full_name && !imageLoadError) {
            <img [src]="employeeImageUrl" (error)="onImageError($event)" alt="profile-placeholder">
            } @else {
            <img src="assets/images/profile-default.jpg" alt="profile-placeholder">
            }
        </div>

        <div class="header-cards">

            <!-- TODO: Hacer componente de card -->
            <div class="card">
                <div class="title">EMPRESA</div>
                <div class="numbers">
                    <span>{{ driver?.employee?.company }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">ANTIGÜEDAD</div>
                <div class="numbers">
                    <span>{{ driver?.employee?.seniority_display }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">ALTA</div>
                <div class="numbers">
                    <mat-icon id="check">check_circle</mat-icon>
                    <span>{{ driver?.employee?.join_date || 'N/A' }}</span>
                    @if(driver?.employee?.reinserted_date != "") {
                        <span>reinsertat: {{ driver?.employee?.reinserted_date }}</span>
                    }
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS USADOS</div>
                <div class="numbers">
                    <span>{{ driver?.vacation_summary?.total_days_used }} de {{
                        driver?.vacation_summary?.total_days_entitled }} días</span>
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS PENDIENTES</div>
                <div class="numbers">
                    @if ((driver?.vacation_summary?.pending_approval_days || 0) > 0) {
                    <mat-icon id="error">error</mat-icon>
                    }
                    <span>{{ driver?.vacation_summary?.pending_approval_days }} días</span>
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS PERSONALES</div>
                <div class="numbers">
                    <span>{{ driver?.vacation_summary?.personal_days_used }} de {{
                        driver?.vacation_summary?.personal_days_entitled }} días usados</span>
                </div>
            </div>

            <div class="card">
                <div class="title">OPERATIVA</div>
                <div class="numbers">
                    <span>{{ operativaName }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">PROTOCOLO</div>
                <div class="numbers">
                    <span>{{ protocolName }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="info">
        <button mat-flat-button id="action" (click)="onGenerateRequest()" >Generar petición </button>
    </div>

</div>

<div class="content">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

        <mat-tab label="PETICIONES PENDIENTES">
            <div class="petitions">
                @for (petition of pendingPetitions; track petition.id) {
                <app-driver-petition [petitions]="petition" [pending]="true" [driverId]="driverId"
                    (petitionRejected)="loadData()"></app-driver-petition>
                } @empty {
                <p>No hay peticiones pendientes</p>
                }
            </div>
        </mat-tab>

        <mat-tab label="CALENDARIO">
            <div class="left">
                <div class="type-selector">
                    <button [class.active]="monthlyView" (click)="monthlyView = true; yearlyView = false;">Mensual</button>
                    <button [class.active]="yearlyView" (click)="yearlyView = true; monthlyView = false;">Anual</button>
                </div>
                @if (monthlyView) {
                <app-calendar [events]="calendarEvents"></app-calendar>
                } @else {
                <app-year-calendar [events]="calendarEvents"></app-year-calendar>
                }
            </div>
            <div class="right">
                <h4>Información</h4>
                <p>Vacaciones, días personales e indisponibilidades del conductor.</p>
                <mat-divider></mat-divider>

                <div class="legend-grid">
                    <div class="legend-item">
                        <div class="available"></div>
                        <span class="legend-text">Disponible para vacaciones</span>
                    </div>
                    <div class="legend-item">
                        <div class="selected"></div>
                        <span class="legend-text">Vacaciones aprobadas</span>
                    </div>
                    <div class="legend-item">
                        <div class="event"></div>
                        <span class="legend-text">Días personales aprobados</span>
                    </div>
                    <div class="legend-item">
                        <div class="blocked"></div>
                        <span class="legend-text">Peticiones pendientes</span>
                    </div>

                    @for (item of unavailabilityLegend; track item.label) {
                    <div class="legend-item">
                        <span class="legend-dot" [style.background]="item.color"></span>
                        <span class="legend-text">{{ item.label }}</span>
                    </div>
                    }
                </div>
            </div>
        </mat-tab>

        <mat-tab label="PETICIONES ANTERIORES">
            <app-driver-petitions-table [requests]="previousRequests"></app-driver-petitions-table>
        </mat-tab>

    </mat-tab-group>

</div>